"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by pavel.arakelyan on 1/9/18.
 */
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var ReportDeserializer = /** @class */ (function () {
    function ReportDeserializer() {
    }
    /**
     * Deserializes from json
     * @param reportJson to deserialize
     * @returns {ReportDto}
     */
    ReportDeserializer.fromJson = function (reportJson) {
        var jsonObject = reportJson;
        var reportDto = new idm_reporting_service_client_js_1.ReportDto();
        reportDto.columnRootDto.children = jsonObject.columnRootDto.children.reduce(function (columnRootChildren, child) {
            if (child.type && child.type === 'ColumnCategoryElement') {
                var columnCategoryDto = ReportDeserializer.deserializeColumnCategoryDto(JSON.stringify(child));
                columnRootChildren.push(columnCategoryDto);
            }
            else if (child.type && child.type === 'ColumnMeasureElement') {
                var columnMeasureDto = ReportDeserializer.deserializeColumnMeasureDto(JSON.stringify(child));
                columnRootChildren.push(columnMeasureDto);
            }
            return columnRootChildren;
        }, []);
        reportDto.rowRootDto.children = jsonObject.rowRootDto.children.reduce(function (rowRootChildren, child) {
            var rowCategoryDto = ReportDeserializer.deserializeRowCategoryDto(JSON.stringify(child));
            rowRootChildren.push(rowCategoryDto);
            return rowRootChildren;
        }, []);
        reportDto.tableGrouping.elements = jsonObject.tableGrouping.elements.reduce(function (tableGroupingElements, child) {
            var tableGroupingCategoryDto = ReportDeserializer.deserializeTableGroupingCategoryDto(JSON.stringify(child));
            tableGroupingElements.push(tableGroupingCategoryDto);
            return tableGroupingElements;
        }, []);
        return reportDto;
    };
    /**
     * Deserializes from json
     * @param json to deserialize
     * @returns {ColumnCategoryDto}
     */
    ReportDeserializer.deserializeColumnCategoryDto = function (json) {
        var jsonObject = JSON.parse(json);
        var columnCategoryDto = new idm_reporting_service_client_js_1.ColumnCategoryDto();
        columnCategoryDto.children = jsonObject.children.reduce(function (children, child) {
            if (child.type && child.type === 'ColumnCategoryElement') {
                var categoryDto = ReportDeserializer.deserializeColumnCategoryDto(JSON.stringify(child));
                children.push(categoryDto);
            }
            else if (child.type && child.type === 'ColumnMeasureElement') {
                var columnMeasureDto = ReportDeserializer.deserializeColumnMeasureDto(JSON.stringify(child));
                children.push(columnMeasureDto);
            }
            return children;
        }, []);
        columnCategoryDto.orderType = jsonObject.orderType;
        columnCategoryDto.filterTreeDto = jsonObject.filterTreeDto ? idm_reporting_service_client_js_1.FilterTreeDto.fromJson(JSON.stringify(jsonObject.filterTreeDto)) : null;
        columnCategoryDto.showOnRowsTotal = jsonObject.showOnRowsTotal;
        columnCategoryDto.categoryElementDto.totalType = jsonObject.categoryElementDto.totalType;
        columnCategoryDto.categoryElementDto.topCount = jsonObject.categoryElementDto.topCount;
        columnCategoryDto.categoryElementDto.otherType = jsonObject.categoryElementDto.otherType;
        columnCategoryDto.categoryElementDto.categoryPathHolderId = jsonObject.categoryElementDto.categoryPathHolderId;
        columnCategoryDto.categoryElementDto.showAsType = jsonObject.categoryElementDto.showAsType;
        columnCategoryDto.categoryElementDto.sortMeasurePathHolderId = jsonObject.categoryElementDto.sortMeasurePathHolderId;
        return columnCategoryDto;
    };
    /**
     * Deserializes from json
     * @param json to deserialize
     * @returns {ColumnMeasureDto}
     */
    ReportDeserializer.deserializeColumnMeasureDto = function (json) {
        var jsonObject = JSON.parse(json);
        var columnMeasureDto = new idm_reporting_service_client_js_1.ColumnMeasureDto();
        columnMeasureDto.children = jsonObject.children.reduce(function (children, child) {
            if (child.type && child.type === 'ColumnCategoryElement') {
                var columnCategoryDto = ReportDeserializer.deserializeColumnCategoryDto(JSON.stringify(child));
                children.push(columnCategoryDto);
            }
            else if (child.type && child.type === 'ColumnMeasureElement') {
                throw new Error('Invalid report, measure cannot have child measure');
            }
            return children;
        }, []);
        columnMeasureDto.orderType = jsonObject.orderType;
        columnMeasureDto.filterTreeDto = jsonObject.filterTreeDto ? idm_reporting_service_client_js_1.FilterTreeDto.fromJson(JSON.stringify(jsonObject.filterTreeDto)) : null;
        columnMeasureDto.showOnRowsTotal = jsonObject.showOnRowsTotal;
        columnMeasureDto.currencyId = jsonObject.currencyId;
        columnMeasureDto.measurePathHolderId = jsonObject.measurePathHolderId;
        columnMeasureDto.isShowInPercentage = jsonObject.isShowInPercentage;
        columnMeasureDto.userDefinedAggregationType = jsonObject.userDefinedAggregationType;
        return columnMeasureDto;
    };
    /**
     * Deserializes from json
     * @param json to deserialize
     * @returns {RowCategoryDto}
     */
    ReportDeserializer.deserializeRowCategoryDto = function (json) {
        var jsonObject = JSON.parse(json);
        var rowCategoryDto = new idm_reporting_service_client_js_1.RowCategoryDto();
        rowCategoryDto.children = jsonObject.children.reduce(function (children, child) {
            var categoryDto = ReportDeserializer.deserializeRowCategoryDto(JSON.stringify(child));
            children.push(categoryDto);
            return children;
        }, []);
        rowCategoryDto.orderType = jsonObject.orderType;
        rowCategoryDto.filterTreeDto = jsonObject.filterTreeDto ? idm_reporting_service_client_js_1.FilterTreeDto.fromJson(JSON.stringify(jsonObject.filterTreeDto)) : null;
        rowCategoryDto.categoryElementDto.totalType = jsonObject.categoryElementDto.totalType;
        rowCategoryDto.categoryElementDto.topCount = jsonObject.categoryElementDto.topCount;
        rowCategoryDto.categoryElementDto.otherType = jsonObject.categoryElementDto.otherType;
        rowCategoryDto.categoryElementDto.categoryPathHolderId = jsonObject.categoryElementDto.categoryPathHolderId;
        rowCategoryDto.categoryElementDto.showAsType = jsonObject.categoryElementDto.showAsType;
        rowCategoryDto.categoryElementDto.sortMeasurePathHolderId = jsonObject.categoryElementDto.sortMeasurePathHolderId;
        return rowCategoryDto;
    };
    /**
     * Deserializes from json
     * @param json to deserialize
     * @returns {TableGroupingCategoryDto}
     */
    ReportDeserializer.deserializeTableGroupingCategoryDto = function (json) {
        var jsonObject = JSON.parse(json);
        var tableGroupingCategoryDto = new idm_reporting_service_client_js_1.TableGroupingCategoryDto();
        tableGroupingCategoryDto.orderType = jsonObject.orderType;
        tableGroupingCategoryDto.categoryElementDto.totalType = jsonObject.categoryElementDto.totalType;
        tableGroupingCategoryDto.categoryElementDto.topCount = jsonObject.categoryElementDto.topCount;
        tableGroupingCategoryDto.categoryElementDto.otherType = jsonObject.categoryElementDto.otherType;
        tableGroupingCategoryDto.categoryElementDto.categoryPathHolderId = jsonObject.categoryElementDto.categoryPathHolderId;
        tableGroupingCategoryDto.categoryElementDto.showAsType = jsonObject.categoryElementDto.showAsType;
        tableGroupingCategoryDto.categoryElementDto.sortMeasurePathHolderId = jsonObject.categoryElementDto.sortMeasurePathHolderId;
        return tableGroupingCategoryDto;
    };
    return ReportDeserializer;
}());
exports.ReportDeserializer = ReportDeserializer;
//# sourceMappingURL=report-deserializer.js.map